import { render, staticRenderFns } from "./RatesSurchargeDetails.vue?vue&type=template&id=580d1f41&scoped=true&"
import script from "./RatesSurchargeDetails.vue?vue&type=script&lang=js&"
export * from "./RatesSurchargeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesSurchargeDetails.vue?vue&type=style&index=0&id=580d1f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d1f41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('580d1f41')) {
      api.createRecord('580d1f41', component.options)
    } else {
      api.reload('580d1f41', component.options)
    }
    module.hot.accept("./RatesSurchargeDetails.vue?vue&type=template&id=580d1f41&scoped=true&", function () {
      api.rerender('580d1f41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesSurchargeDetails.vue"
export default component.exports